module.exports = __webpack_public_path__ + "static/img/03ai.f44c12c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/status/23checkupDesc/03ai.png
// module id = wVKC
// module chunks = 0